import { Briefcase, Building2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

export type Audience = "business" | "accountant";

interface AudienceToggleProps {
  value: Audience;
  onChange: (value: Audience) => void;
}

/**
 * Pill-shaped segmented control with icon-circles. The leading circle stays
 * neutral when inactive, and flips to filled olive (`--fx-accent-500`) when
 * the button is selected — the only place olive appears in the resting card,
 * so the eye lands on the chosen audience.
 */
export function AudienceToggle({
  value,
  onChange,
}: AudienceToggleProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div
      className="fx-audience"
      role="tablist"
      aria-label={t("auth.audience.label", "Tipo de cuenta")}
    >
      <button
        type="button"
        role="tab"
        aria-selected={value === "business"}
        className={cn("fx-audience-btn", value === "business" && "is-active")}
        onClick={() => onChange("business")}
      >
        <span className="ico" aria-hidden>
          <Building2 />
        </span>
        {t("auth.audience.business", "Soy empresa")}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={value === "accountant"}
        className={cn("fx-audience-btn", value === "accountant" && "is-active")}
        onClick={() => onChange("accountant")}
      >
        <span className="ico" aria-hidden>
          <Briefcase />
        </span>
        {t("auth.audience.accountant", "Soy contador")}
      </button>
    </div>
  );
}
